export const GET_ASSIGNMENTS = 'GET_ASSIGNMENTS'
